module.exports = __webpack_public_path__ + "static/media/jo.624b48f7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/countriesFlags/jo.svg
// module id = 1454
// module chunks = 0